module.exports = __webpack_public_path__ + "img/Skill-future-new.571d31eb.png";